module.exports = {
    server: 'https://www.khyoga.net',
    // server: 'https://yogatest.jkxuetang.com',
    // server: 'http://mine.revolutionary.com',
    apiversion: 'v1', //系统api版本
    apiname: 'topapi', //系统配置的api名称
    pagesize: 10, // 分页组件每页显示数量
    cpage: 1, //分页当前页
    apimethod: { //接口method集合
        getBanners:'/api/v1/banner/list',//banner
        getAboutUs:'/api/v1.about/about',//关于我们
        getNewInfo:'/api/v1/train/new_info',//最新培训
        getTeacher:'/api/v1/teacher',//
        getPastsilhouette:'/api/v1/pastsilhouette',//
        getTrainCateList:'/api/v1/train/train_cate_list',//
        getTrainList:'/api/v1/train/train_index_list',//
        getTrainBaseInfo :'/api/v1/train/base_info',//获取培训基础信息
        getTrainFrontTrainInfo  :'/api/v1/train/front_train_info',//获取培训前置条件信息
        getTrainPromotionInfo :'/api/v2/train/promotion_info',//获取培训特惠活动信息
        getOnlineCourseCateList:'/api/v1/online/course/cate_list', // 在线课程分类列表
        getOnlineCourseList:'/api/v1/online/course/list', // 在线课程列表
        getOnlineCourseList_v2:'/api/v2/online/course/list', // 在线课程列表_v2
        getOnlineCourseCateList_v2:'/api/v2/online/course/all_cate_list', // 在线课程分类列表_v2
        getOnlineCourseDetail:'/api/v1/online/course/detail', // 在线课程详情
        getProductCateList:'/api/v1/product/cate_list', // 商品分类列表
        getProductList:'/api/v1/product/list', // 商品列表(可根据条件查询)
        getProductDetail:'/api/v1/product/detail', // 商品详情
    }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/myconfig.js
// module id = p8Lf
// module chunks = 1